import React, {useEffect} from 'react';
import Header from "../components/Header";

function AdatkezelesiTajekoztato() {
    document.title = "Adatkezelési tájékoztató"

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return <div className={"content adatkezelesi-tajekoztato"}>
        <h1>Adatkezelési tájékoztató</h1>
        <p>HATÁLYOS: 2025.11.05. napjától</p>

        <h2>A TETŐ- ÉS TÉRKŐMOSÁS ÁLTALÁNOS ADATKEZELÉSI TÁJÉKOZTATÓJA</h2>
        <p>HSG-Fémipari Kft. képviseletében üzemeltetett <b><i>Tető- és térkőmosás</i></b>, a tevékenysége során birtokába jutott, vagy általa rögzített személyes adatokat az Európai Parlament és Tanács a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK irányelv hatályon kívül helyezéséről szóló 2016/679. számú rendelet és az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény rendelkezéseinek megfelelően az alábbiak szerint kezeli.</p>
        <h3>A tájékoztató célja, hatálya:</h3>
        <p>A jelen tájékoztató célja, hogy rögzítse a <b><i>Tető- és térkőmosás</i></b> által alkalmazott adatvédelmi és -kezelési elveket, valamint adatvédelmi és -kezelési politikáját, amelyet <b><i>Tető- és térkőmosás</i></b> mint adatkezelő magára nézve kötelező erővel ismer el.</p>
        <br/>
        <p>A <b><i>Tető- és térkőmosás</i></b> mint adatkezelő a jelen tájékoztató nyilvánosságra hozatalával tájékoztatja az érintetteket a személyes adatok kezelésével kapcsolatos általános információkról.</p>
        <h3>Adatkezelő:</h3>
        <p>HSG-Fémipari Kft.</p>
        <p>Székhely: 4400 Nyíregyháza, Eperjes utca 12. 8. emelet 25.</p>
        <br/>
        <p>Ha az alábbiakban részletezett adatkezelésekkel kapcsolatban bármilyen kérdése merülne fel, kérjük az alábbi elérhetőségek egyikén keresztül vegye fel velünk a kapcsolatot:</p>
        <p>Telefon: +36 30 480 9842</p>
        <p>email: info@tetoesterkomosas.hu</p>

        <h3>A kezelt adatok köre:</h3>
        <table>
            <thead>
            <tr>
                <th>Adatkezelés megnevezése</th>
                <th>A kezelt adatok köre</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Ügyfélkapcsolati, adminisztrációs adatok</td>
                <td>Természetes személyazonosító adatok, név, cégnév, e- mail cím, illetve az ügyfél által szöveges mezőben megadott egyéb adatok</td>
            </tr>
            <tr>
                <td>Szerződésben kezelt adatok</td>
                <td>Természetes személyazonosító adatok, név, cégnév, e- mail cím, telefonszám, lakcím</td>
            </tr>
            </tbody>
        </table>

        <h3>Adatkezelés jogalapja:</h3>
        <table>
            <thead>
            <tr>
                <th>Adatkezelés megnevezése</th>
                <th>Az adatkezelés jogalapja</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Ügyfélkapcsolati, adminisztrációs adatok</td>
                <td>Az Ön hozzájárulása</td>
            </tr>
            <tr>
                <td>Szerződésben kezelt adatok</td>
                <td>Az Ön hozzájárulása</td>
            </tr>
            </tbody>
        </table>

        <h3>Az adatkezelés célja:</h3>
        <table>
            <thead>
            <tr>
                <th>Adatkezelés megnevezése</th>
                <th>Az adatkezelés jogalapja</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>Ügyfélkapcsolati, adminisztrációs adatok</td>
                <td>A <b><i>Tető- és térkőmosás</i></b>  eljárásainak támogatása, ügyfél megkeresések megválaszolása</td>
            </tr>
            <tr>
                <td>Szerződésben kezelt adatok</td>
                <td>Szerződés alapján történő kapcsolatfelvétel és szerződött szolgáltatások nyújtása</td>
            </tr>
            </tbody>
        </table>

        <h3>Az adatkezelés ideje:</h3>
        <table>
            <thead>
            <tr>
                <th>Adatkezelés megnevezése</th>
                <th>Az adatkezelés jogalapja</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>A <b><i>Tető- és térkőmosás</i></b> honlapjának látogatása során kezelt adatok</td>
                <td>A honlap látogatásakor gyűjtött technikai adatok tekintetében a célhoz kötötten megállapított idő</td>
            </tr>
            <tr>
                <td>Ügyfélkapcsolati, adminisztrációs adatok</td>
                <td>Jogszabályban előírt megőrzési idő, a regisztrációs adatok esetében a visszavonásig, de legfeljebb 2 év</td>
            </tr>
            <tr>
                <td>Szerződésben kezelt adatok</td>
                <td>Szerződés ideje + 5 év</td>
            </tr>
            </tbody>
        </table>

        <h3>Kiknek az adatait kezeljük, érintettek köre:</h3>
        <table>
            <thead>
            <tr>
                <th>Adatkezelés megnevezése</th>
                <th>Az adatkezelés jogalapja</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>A <b><i>Tető- és térkőmosás</i></b> honlapjának látogatása során kezelt adatok</td>
                <td>A <b><i>Tető- és térkőmosás</i></b> honlapját látogató természetes személyek</td>
            </tr>
            <tr>
                <td>Ügyfélkapcsolati, adminisztrációs adatok</td>
                <td>A <b><i>Tető- és térkőmosás</i></b> természetes személy ügyfelei</td>
            </tr>
            <tr>
                <td>Szerződésben kezelt adatok</td>
                <td>Szerződő cég képviselője vagy magánszemély</td>
            </tr>
            </tbody>
        </table>

        <h3>Adattovábbítás:</h3>
        <p>A <b><i>Tető- és térkőmosás</i></b> az adatokat a hatósági eljárások során, illetve egyéb feladataiból adódóan, jogszabályban meghatározott címzettek felé továbbítja. Az adattovábbításokról minden érintett tájékoztatást kérhet „az adatkezeléssel összefüggő jogok” fejezetben leírtak szerint.</p>

        <h3>Adatbiztonsági intézkedések:</h3>
        <p>A <b><i>Tető- és térkőmosás</i></b> az elektronikus formában nyilvántartott személyes adatokat a saját szerverein tárolja, adatfeldolgozót esetenként vesz igénybe. Az adatkezelés bármilyen kiszervezése esetén megbizonyosodik arról, hogy az igénybe vett szolgáltató biztosítja az adatkezelés megfelelő garanciáit. A <b><i>Tető- és térkőmosás</i></b> megfelelő intézkedésekkel gondoskodik arról, hogy a személyes adatokat védje – többek között – a jogosulatlan hozzáféréstől vagy megváltoztatástól.</p>

        <h3>Tájékoztatáshoz és hozzáféréshez való jog:</h3>
        <p>Ön az „Adatkezelő” alcím alatt megadott elérhetőségeken keresztül, írásban tájékoztatást kérhet <b><i>Tető- és térkőmosás</i></b>-tól arról, hogy <b><i>Tető- és térkőmosás</i></b>:</p>
        <ul>
            <li>milyen személyes adatait,</li>
            <li>milyen jogalapon</li>
            <li>milyen célból,</li>
            <li>milyen forrásból,</li>
            <li>mennyi ideig kezeli,</li>
            <li>kezeli-e még a személyes adatait,</li>
            <li>kinek, mikor, milyen okból és mely személyes adataihoz biztosított hozzáférést vagy kinek továbbította a személyes</li>
        </ul>
        <p>Ezen felül kérheti <b><i>Tető- és térkőmosás</i></b> által tárolt személyes adatainak másolatát.</p>
        <br/>
        <p><b><i>Tető- és térkőmosás</i></b> az Ön kérelmét legfeljebb 30 napon belül, a kérelemben megadott elérhetőségre megküldött válaszlevelében teljesíti. Ha a kérelmet elektronikus úton küldi meg <b><i>Tető- és térkőmosás</i></b>-hoz, akkor <b><i>Tető- és térkőmosás</i></b> válaszlevele is – lehetőség szerint – elektronikus úton érkezik meg. Ha más úton kéri megküldeni a választ, kérjük, jelezze ezt a kérelemben.</p>

        <h3>Helyesbítéshez való jog:</h3>
        <p>Ön az „Adatkezelő” alcím alatt megadott elérhetőségeken keresztül, írásban kérheti, hogy <b><i>Tető- és térkőmosás</i></b> módosítsa vagy pontosítsa valamely személyes adatát (pl. a nevét, e-mail címét, ha abban változás következett be). Ha a kérelmet elektronikus úton küldi meg <b><i>Tető- és térkőmosás</i></b> -hoz, akkor <b><i>Tető- és térkőmosás</i></b> válaszlevele is – lehetőség szerint – elektronikus úton érkezik meg Önhöz. Ha más úton kéri megküldeni a választ, kérjük, jelezze ezt a kérelemben.</p>
        <br/>
        <p><b><i>Tető- és térkőmosás</i></b> a kérelmét indokolatlan késedelem nélkül legfeljebb 30 napon belül teljesíti és erről a kérelmet benyújtót az általa megadott elérhetőségre küldött levélben értesíti.</p>

        <h3>A törléshez való jog („az elfeledtetéshez való jog”):</h3>
        <p>Ön az „Adatkezelő” alcím alatt megadott elérhetőségeken keresztül, írásban kérheti <b><i>Tető- és térkőmosás</i></b> -tól a személyes adatainak törlését.</p>
        <br/>
        <p>A törlési kérelmet <b><i>Tető- és térkőmosás</i></b> abban az esetben utasítja el, ha jogszabály a személyes adatok további tárolására kötelezi <b><i>Tető- és térkőmosás</i></b> -t. Ha azonban a törölni kért személyes adatra nincs ilyen kötelezettség, akkor <b><i>Tető- és térkőmosás</i></b> a kérelmet indokolatlan késedelem nélkül, legfeljebb 30 napon belül teljesíti, és erről a kérelmet benyújtót az általa megadott elérhetőségére küldött válaszlevélben értesíti. Ha a kérelmet elektronikus úton küldi meg <b><i>Tető- és térkőmosás</i></b> -hoz, akkor <b><i>Tető- és térkőmosás</i></b> válaszlevele is – lehetőség szerint – elektronikus úton érkezik meg Önhöz. Ha más úton kéri megküldeni a választ, kérjük, jelezze ezt a kérelemben.</p>

        <h3>Az adatkezelés korlátozásához való jog:</h3>
        <p>Ön az „Adatkezelő” alcím alatt megadott elérhetőségeken keresztül, írásban kérheti <b><i>Tető- és térkőmosás</i></b> -tól az adatkezelés korlátozását. Korlátozás esetén <b><i>Tető- és térkőmosás</i></b> csak tárolhatja a személyes adatot, egyéb adatkezelési tevékenység kizárólag a korlátozást kérő hozzájárulásával jogi igény előterjesztése miatt, vagy közérdekből történhet.</p>
        <br/>
        <p>Az adatok korlátozását akkor lehet kérni, ha:</p>
        <ul>
            <li>úgy gondolja, hogy adatai nem pontosak, vagy</li>
            <li>úgy gondolja, hogy adatait <b><i>Tető- és térkőmosás</i></b> jogellenesen kezelte, de az adat törlését nem szeretné,</li>
            <li>igényli az adatkezelést jogi igénye érvényesítése vagy védelme miatt, de már <b><i>Tető- és térkőmosás</i></b> -nak nincs szüksége ezekre az</li>
        </ul>
        <p><b><i>Tető- és térkőmosás</i></b> a kérelmét indokolatlan késedelem nélkül, legfeljebb 30 napon belül teljesíti és erről a kérelmet benyújtót az általa megadott elérhetőségre küldött levélben értesíti. Ha a kérelmet elektronikus úton küldi meg <b><i>Tető- és térkőmosás</i></b> -hoz, akkor <b><i>Tető- és térkőmosás</i></b> válaszlevele is – lehetőség szerint – elektronikus úton érkezik meg Önhöz. Ha más úton kéri megküldeni a választ, kérjük, jelezze ezt a kérelemben.</p>

        <h3>A hozzájárulás visszavonásának joga:</h3>
        <p>Ön az „Adatkezelő” alcím alatt megadott elérhetőségeken keresztül, írásban, az adatkezelés időtartama alatt bármikor visszavonhatja hozzájárulását az adatkezeléshez. A hozzájárulás visszavonása esetén <b><i>Tető- és térkőmosás</i></b>  visszavonás előtti adatkezelése továbbra is jogszerű marad.</p>
        <br/>
        <p><b><i>Tető- és térkőmosás</i></b>  a személyes adatokat a visszavonás beérkezését követően indokolatlan késedelem nélkül törli, és erről a nyilatkozatot tevőt az általa megadott elérhetőségre küldött levélben értesíti. Ha a kérelmet elektronikus úton küldi meg <b><i>Tető- és térkőmosás</i></b>  -hoz, akkor <b><i>Tető- és térkőmosás</i></b>  válaszlevele is – lehetőség szerint – elektronikus úton érkezik meg Önhöz. Ha más úton kéri megküldeni a választ, kérjük, jelezze ezt a nyilatkozatában.</p>

        <h3>Jogorvoslati lehetőség:</h3>
        <p>Amennyiben az Ön megítélése szerint az adatkezelés nem felelt meg a jogszabályi követelményeknek, kezdeményezheti <b><i>Tető- és térkőmosás</i></b>  adatvédelmi felelősének eljárását, illetve bírósághoz fordulhat.</p>
        <br/>
        <p>Ezen felül a Nemzeti Adatvédelmi és Információszabadság Hatóságnál bejelentéssel bárki vizsgálatot kezdeményezhet arra hivatkozással, hogy személyes adatok kezeléséhez fűződő jogok gyakorlásával kapcsolatban jogsérelem következett be, vagy annak közvetlen veszélye fennáll.</p>

        <h3>Nemzeti Adatvédelmi és Információszabadság Hatóság elérhetősége:</h3>
        <p>Nemzeti Adatvédelmi és Információszabadság Hatóság Székhely: 1125 Budapest, Szilágyi Erzsébet fasor 22/C. Postacím: 1530 Budapest, Pf.: 5.</p>
        <p>Telefon: 06-1-391-1400</p>
        <p>Telefax: 06-1-391-1410</p>
        <p>E-mail: ugyfelszolgalat@naih.hu</p>

        <h3>Az általános tájékoztatótól eltérő részletes Információk:</h3>
        <h3>A www.tetoesterkomosas.hu  honlapjával kapcsolatos adatkezelés részletei:</h3>
        <p>A weboldal látogatása során az Ön adatainak felelős kezelője: HSG-Fémipari Kft.</p>
        <br/>
        <p>Amikor Ön a <b><i>Tető- és térkőmosás</i></b> internetes honlapját látogatja, közben személyes adatait is átadja számunkra.</p>
        <br/>
        <p>Személyes adatai (vagyis azok az adatok, amelyek az Ön személyével kapcsolatba hozhatók) a következő módon kerülhetnek a kezelésünkbe: egyfelől az internetes kapcsolat fenntartásával összefüggésben az Ön által használt számítógéppel, böngészőprogrammal, internetes címmel, a látogatott oldalakkal kapcsolatos technikai adatok automatikusan képződnek számítógépes rendszerünkben, másfelől Ön is megadhatja nevét, elérhetőségét vagy más adatait, ha a honlap használata során személyes kapcsolatba kíván lépni velünk.</p>
        <br/>
        <p>A weboldalon lévő legtöbb információ megtekintéséhez regisztráció vagy bejelentkezési adatok megadása nem szükséges. Vannak azonban olyan funkciók, melyek igénybevételéhez bizonyos személyes adatok megadására (név, e-mail cím) szükség lehet.</p>
        <br/>
        <p>Amennyiben Ön bármely személyes adatát a weboldalon keresztül eljuttatja <b><i>Tető- és térkőmosás</i></b>-hoz, a beküldés során hozzájárulását adja ahhoz, hogy azt <b><i>Tető- és térkőmosás</i></b>  – az ügylet jellege által meghatározott célból és ideig – nyilvántartsa és kezelje.</p>
        <br/>
        <p><b><i>Tető- és térkőmosás</i></b>  honlapján keresztül <b><i>Tető- és térkőmosás</i></b>  tudomására jutott adatokat harmadik személy számára – a törvényben meghatározott eseteken kívül – semmilyen körülmények között nem adja ki.</p>
        <br/>
        <p><b><i>Tető- és térkőmosás</i></b>  az Ön által az Interneten keresztül megadott személyes jellegű adatokat ugyanolyan biztonsági fokú védelemmel kezeli, mint az egyéb úton rendelkezésre bocsátott adatokat.</p>
        <br/>
        <p>Ezen szabályzat mindenkor hatályos rendelkezéseit a www.tetoesterkomosas.hu weboldal folyamatosan tartalmazza. Esetleges ellentmondás esetén mindig az előbbi helyre feltöltött szabályzat rendelkezései az irányadók, mint hatályos rendelkezések.</p>
        <br/>
        <p>Nyíregyháza, 2025.11.05.</p>
        <br/>
        <p><b>HSG-Fémipari Kft.</b></p>
    </div>
}

export default AdatkezelesiTajekoztato;